import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MemberPlot } from '../models/member-plot.model';
import { ColumnConfig } from '../../../shared/models/column-config.model';
import { MemberPlotsService } from '../member-plots.service';
import { FormBuilder, Validators } from '@angular/forms';
import { TitleService } from '../../../shared/services/title.service';
import { PlotsService } from '../../plots/plots.service';
import { ChildDataTableDirective } from '../../../shared/directives/child-data-table.directive';
import { combineLatest, EMPTY, Observable, switchMap } from 'rxjs';
import { ResultSet } from '../../../shared/models/result-set.model';
import { NotificationService } from '../../../shared/services/notification.service';
import { PageStateManagerService } from '../../../shared/services/page-state-manager.service';
import { AuthService } from '../../../shared/services/auth.service';

@Component({
  selector: 'app-member-plots-list',
  standalone: false,  
  templateUrl: './member-plots-list.component.html',  
})
export class MemberPlotsListComponent extends ChildDataTableDirective<MemberPlot> implements OnInit {
  
  override columns: ColumnConfig[] = [];
  override modelName: string = 'Member Plot';

  constructor(   
    private plotsService: PlotsService, 
    private memberPlotsService: MemberPlotsService, 
    fb: FormBuilder, 
    route: ActivatedRoute, 
    router: Router, 
    titleService: TitleService,
    notificationService: NotificationService,
    pageStateManager: PageStateManagerService,
    authService: AuthService,
  ) {
    super(
      memberPlotsService, 
      fb, 
      route, 
      router, 
      titleService, 
      notificationService,
      pageStateManager,
      authService
    );       
  }

   


  override ngOnInit() {
    this.columns = [
      { 
        name: 'plotId', 
        label: 'Plot Number', 
        inputType: 'select',
        options: [],
        validators: [Validators.required],
        errorMessages: { required: 'Plot Number is required' },
        displayColumn: 'plot.plotNumber'        
      },      
      { 
        name: 'startDate', 
        label: 'Start Date', 
        inputType: 'date',
        validators: [Validators.required],
        errorMessages: { required: 'Start Date is required' }
      },
      { 
        name: 'endDate', 
        label: 'EndDate', 
        inputType: 'date'
      },
      {
        name: 'invoice',
        label: 'Invoice',
        inputType: 'checkbox',}
    ];
    this.setOptions()    
    this.route.paramMap.subscribe(params => {        
        this.parentID = parseInt(params.get('memberId')!);        
    });   
    super.ngOnInit(); 
  }

  protected override buildResultSet$(): Observable<ResultSet<MemberPlot>> {    
    return combineLatest([
          this.currentPageSubject,
          this.pageSizeSubject
        ]).pipe(          
          switchMap(([page, size]) => {
            if(!this.parentID) {
              console.error('Parent ID not set');
              return EMPTY
            }
            const offset = (page - 1) * size;            
            return this.memberPlotsService.getPlotsForMember(this.parentID, offset, size);
          })
        );
  }

  override onGoBack() {
    this.router.navigate(['/members']);
  }

  override onCreate(item: MemberPlot): void {
    if (!this.parentID) {
      console.error('Parent ID not set');
      return;
    }
    item.memberId = this.parentID;
    super.onCreate(item);
  }

  private async setOptions() {
    this.plotsService.getAll(0,200).subscribe(plots => {
      const plotOptions = plots.data.map(plot => ({
        value: plot.id, 
        label: plot.plotNumber
      }));
  
      // Find the relevant column and set options
      const plotNumberColumn = this.columns.find(col => col.name === 'plotId');
      if (plotNumberColumn) {
        plotNumberColumn.options = plotOptions;
      }
    });

  }

}
